import { styled } from '@ringcentral/juno';

export const StickyWrap = styled.div`
  width: 100%;
  z-index: 100;
`;
